import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import 'config/config';
import { Provider } from 'react-redux';
import { store } from '@app/store/store';
import ReactDOM from 'react-dom';
import React from 'react';
import { renderMockFailure, startApp } from '@app/smart-audit/startApp';

interface EventTarget {
  state?: 'activated';
}

const renderApp = () => {
  ReactDOM.render(
    <React.StrictMode>
      <Provider store={store}>
        <App />
      </Provider>
    </React.StrictMode>,
    document.getElementById('root'),
  );
};

const bootstrap = () =>
  startApp({
    // Constant-folded by CRA's DefinePlugin: production builds drop the dynamic import with the dead branch.
    // If the mock is on but cannot start, the app is not rendered (it would call the real servers): see startApp.
    startMock:
      process.env.NODE_ENV === 'development' && process.env.REACT_APP_SMART_AUDIT_MOCK === 'true'
        ? () => import('./smart-audit/mocks/browser').then(({ startMockWorker }) => startMockWorker())
        : null,
    renderApp,
    renderFailure: () => renderMockFailure(document.getElementById('root')),
  });

bootstrap();

serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    const waitingServiceWorker = registration.waiting;

    if (waitingServiceWorker) {
      waitingServiceWorker.addEventListener('statechange', (event) => {
        if ((event.target as EventTarget).state === 'activated') window.location.reload();
      });
      waitingServiceWorker.postMessage({ type: 'SKIP_WAITING' });
    }
  },
}); // app will reload if new version of app is available

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
